/**
 * Created by gusenlin on 2018/5/3.
 */

export function formatDate(time, flag) {
  let date = new Date(time);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let H = date.getHours();
  let f = date.getMinutes();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  f = f < 10 ? '0' + f : f + '';
  H = H < 10 ? '0' + H : H + '';
  if (flag) {
    return y + '-' + m + '-' + d;
  } else return y + '-' + m + '-' + d + ' ' + H + ':' + f;
}

export function formatUtcDate(time) {
  time = time.replace(/\-/gm, '/');
  let date = new Date(time);
  let y = date.getUTCFullYear();
  let m = date.getUTCMonth() + 1;
  let d = date.getUTCDate();
  let H = date.getUTCHours();
  let f = date.getUTCMinutes();
  let ss = date.getUTCSeconds();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  H = H < 10 ? '0' + H : H + '';
  f = f < 10 ? '0' + f : f + '';
  ss = ss < 10 ? '0' + ss : ss + '';
  return y + '-' + m + '-' + d + 'T' + H + ':' + f + ':' + ss + 'Z';
}

export function formatUtcDateV2(time) {
  let date = new Date(time);
  if (date.toString() === 'Invalid Date') {
    if (typeof time === 'string') {
      date = new Date(time.replace(/\-/gm, '/'));
    }
  }
  let y = date.getUTCFullYear();
  let m = date.getUTCMonth() + 1;
  let d = date.getUTCDate();
  let H = date.getUTCHours();
  let f = date.getUTCMinutes();
  let ss = date.getUTCSeconds();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  H = H < 10 ? '0' + H : H + '';
  f = f < 10 ? '0' + f : f + '';
  ss = ss < 10 ? '0' + ss : ss + '';
  return y + '-' + m + '-' + d + 'T' + H + ':' + f + ':' + ss + 'Z';
}

export function formatUtcDateByExpenseComp(time) {
  let date = new Date(time);
  if (date.toString() === 'Invalid Date') {
    if (typeof time === 'string') {
      date = new Date(time.replace(/\-/gm, '/'));
    }
  }
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let H = date.getHours();
  let f = date.getMinutes();
  let ss = date.getSeconds();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  H = H < 10 ? '0' + H : H + '';
  f = f < 10 ? '0' + f : f + '';
  ss = ss < 10 ? '0' + ss : ss + '';
  return y + '-' + m + '-' + d + 'T' + H + ':' + f + ':' + ss + 'Z';
}

//获取格式化的本地日期对象字符串
export function formatLocalData(utc, format) {
  let formatDesc = 'yyyy-MM-dd';
  if (format) {
    formatDesc = format;
  }
  try {
    let data = new Date(utc);
    return data.Format(formatDesc);
  } catch (e) {
    return utc;
  }
}

export function getExpenseDate(date) {
  let day = new Date(date).getDay();
  const dayNames = [
    window.$t('other-1.key28', { cm: '周日' }),
    window.$t('other-1.key29', { cm: '周一' }),
    window.$t('other-1.key30', { cm: '周二' }),
    window.$t('other-1.key31', { cm: '周三' }),
    window.$t('other-1.key32', { cm: '周四' }),
    window.$t('other-1.key33', { cm: '周五' }),
    window.$t('other-1.key34', { cm: '周六' }),
  ];
  return dayNames[day];
}

//转换服务器时间为   年/月/日 时:分   or    年/月/日 时:分:秒
export function formatDateVersion1(time, isShowSecond) {
  let date = new Date(time);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let H = date.getHours();
  let f = date.getMinutes();
  let ss = date.getSeconds();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  f = f < 10 ? '0' + f : f + '';
  H = H < 10 ? '0' + H : H + '';
  if (isShowSecond) {
    return y + '/' + m + '/' + d + '' + H + ':' + f + ':' + ss;
  } else return y + '/' + m + '/' + d + ' ' + H + ':' + f;
}

// 给 停机公告 做 时间转换
export function formatDateForStopMachine(startTime, endTime) {
  let sTime = new Date(startTime);
  let eTime = new Date(endTime);
  let sy = sTime.getFullYear();
  let sm = sTime.getMonth() + 1;
  let sd = sTime.getDate();
  let sH = sTime.getHours();
  let sf = sTime.getMinutes();
  // let ey = eTime.getFullYear();
  let em = eTime.getMonth() + 1;
  let ed = eTime.getDate();
  let eH = eTime.getHours();
  let ef = eTime.getMinutes();
  sm = sm < 10 ? '0' + sm : sm + '';
  sd = sd < 10 ? '0' + sd : sd + '';
  sf = sf < 10 ? '0' + sf : sf + '';
  sH = sH < 10 ? '0' + sH : sH + '';
  em = em < 10 ? '0' + em : em + '';
  ed = ed < 10 ? '0' + ed : ed + '';
  ef = ef < 10 ? '0' + ef : ef + '';
  eH = eH < 10 ? '0' + eH : eH + '';
  if (sm === em && sd === ed) {
    return sy + '/' + sm + '/' + sd + ' ' + sH + ':' + sf + '~' + eH + ':' + ef;
  } else {
    return sy + '/' + sm + '/' + sd + ' ' + sH + ':' + sf + '~' + sy + '/' + em + '/' + ed + ' ' + eH + ':' + ef;
  }
}
